import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { suggestEmail } from 'utils/suggest-email';

const Wrap = styled.div`
    font-size: 13px;
    color: #555;
    margin: -4px 0 8px 0;
    text-align: left;
`;

const AcceptButton = styled.button`
    appearance: none;
    background: none;
    border: none;
    padding: 0;
    color: #1e7ad1;
    text-decoration: underline;
    cursor: pointer;
    font: inherit;
`;

const DismissButton = styled(AcceptButton)`
    color: #999;
    margin-left: 8px;
`;

export const useEmailSuggestion = () => {
    const [suggestion, setSuggestion] = useState(null);

    const checkEmail = useCallback(email => {
        setSuggestion(suggestEmail(email));
    }, []);

    const clearSuggestion = useCallback(() => {
        setSuggestion(null);
    }, []);

    const SuggestionMessage = useCallback(({ onAccept }) => {
        if (!suggestion) return null;
        const accept = () => {
            if (onAccept) onAccept(suggestion);
            setSuggestion(null);
        };
        return (
            <Wrap>
                Did you mean{' '}
                <AcceptButton type="button" onClick={accept}>{suggestion}</AcceptButton>?
                <DismissButton type="button" onClick={() => setSuggestion(null)}>No</DismissButton>
            </Wrap>
        );
    }, [suggestion]);

    return { suggestion, checkEmail, clearSuggestion, SuggestionMessage };
};
